import { Button } from '@components/primitives/Button';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  onSchedule?: () => void;
}

/**
 * Pure UI component for empty state when no appointments exist
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ onSchedule }) => {
  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 250,
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, color: 'text.secondary', fontWeight: 400 }}
      >
        No upcoming appointments
      </Typography>
      
      <Typography 
        variant="body2" 
        sx={{ mb: 3, color: 'text.secondary', maxWidth: 300 }}
      >
        Your schedule is clear. Schedule an appointment when you&apos;re ready.
      </Typography>

      {onSchedule && (
        <Button
          variant="contained"
          color="primary"
          onClick={onSchedule}
        >
          Schedule Appointment
        </Button>
      )}
    </Box>
  );
};